import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { forwardRef, ChangeDetectionStrategy, Component, EventEmitter, Input, KeyValueDiffers, NgZone, Output, ViewChild, NgModule } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} str
 * @return {?}
 */
function normalizeLineEndings(str) {
    if (!str) {
        return str;
    }
    return str.replace(/\r\n|\r/g, '\n');
}
var CodemirrorComponent = /** @class */ (function () {
    function CodemirrorComponent(_differs, _ngZone) {
        this._differs = _differs;
        this._ngZone = _ngZone;
        /* class applied to the created textarea */
        this.className = '';
        /* name applied to the created textarea */
        this.name = 'codemirror';
        /* autofocus setting applied to the created textarea */
        this.autoFocus = false;
        /* preserve previous scroll position after updating value */
        this.preserveScrollPosition = false;
        /* called when the text cursor is moved */
        this.cursorActivity = new EventEmitter();
        /* called when the editor is focused or loses focus */
        this.focusChange = new EventEmitter();
        /* called when the editor is scrolled */
        this.scroll = new EventEmitter();
        this.value = '';
        this.disabled = false;
        this.isFocused = false;
        /**
         * Implemented as part of ControlValueAccessor.
         */
        this.onChange = (/**
         * @param {?} _
         * @return {?}
         */
        function (_) { });
        /**
         * Implemented as part of ControlValueAccessor.
         */
        this.onTouched = (/**
         * @return {?}
         */
        function () { });
    }
    Object.defineProperty(CodemirrorComponent.prototype, "options", {
        /**
         * set options for codemirror
         * @link http://codemirror.net/doc/manual.html#config
         */
        set: /**
         * set options for codemirror
         * @link http://codemirror.net/doc/manual.html#config
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._options = value;
            if (!this._differ && value) {
                this._differ = this._differs.find(value).create();
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    CodemirrorComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (!this.ref) {
            return;
        }
        // in order to allow for universal rendering, we import Codemirror runtime with `require` to prevent node errors
        var fromTextArea = require('codemirror').fromTextArea;
        this._ngZone.runOutsideAngular((/**
         * @return {?}
         */
        function () {
            _this.codeMirror = fromTextArea(_this.ref.nativeElement, _this._options);
            _this.codeMirror.on('cursorActivity', (/**
             * @param {?} cm
             * @return {?}
             */
            function (cm) {
                return _this._ngZone.run((/**
                 * @return {?}
                 */
                function () { return _this.cursorActive(cm); }));
            }));
            _this.codeMirror.on('scroll', _this.scrollChanged.bind(_this));
            _this.codeMirror.on('blur', (/**
             * @return {?}
             */
            function () {
                return _this._ngZone.run((/**
                 * @return {?}
                 */
                function () { return _this.focusChanged(false); }));
            }));
            _this.codeMirror.on('focus', (/**
             * @return {?}
             */
            function () {
                return _this._ngZone.run((/**
                 * @return {?}
                 */
                function () { return _this.focusChanged(true); }));
            }));
            _this.codeMirror.on('change', (/**
             * @param {?} cm
             * @param {?} change
             * @return {?}
             */
            function (cm, change) {
                return _this._ngZone.run((/**
                 * @return {?}
                 */
                function () { return _this.codemirrorValueChanged(cm, change); }));
            }));
            _this.codeMirror.setValue(_this.value);
        }));
    };
    /**
     * @return {?}
     */
    CodemirrorComponent.prototype.ngDoCheck = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (!this._differ) {
            return;
        }
        // check options have not changed
        /** @type {?} */
        var changes = this._differ.diff(this._options);
        if (changes) {
            changes.forEachChangedItem((/**
             * @param {?} option
             * @return {?}
             */
            function (option) {
                return _this.setOptionIfChanged(option.key, option.currentValue);
            }));
            changes.forEachAddedItem((/**
             * @param {?} option
             * @return {?}
             */
            function (option) {
                return _this.setOptionIfChanged(option.key, option.currentValue);
            }));
            changes.forEachRemovedItem((/**
             * @param {?} option
             * @return {?}
             */
            function (option) {
                return _this.setOptionIfChanged(option.key, option.currentValue);
            }));
        }
    };
    /**
     * @return {?}
     */
    CodemirrorComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        // is there a lighter-weight way to remove the cm instance?
        if (this.codeMirror) {
            this.codeMirror.toTextArea();
        }
    };
    /**
     * @param {?} cm
     * @param {?} change
     * @return {?}
     */
    CodemirrorComponent.prototype.codemirrorValueChanged = /**
     * @param {?} cm
     * @param {?} change
     * @return {?}
     */
    function (cm, change) {
        if (change.origin !== 'setValue') {
            this.value = cm.getValue();
            this.onChange(this.value);
        }
    };
    /**
     * @param {?} optionName
     * @param {?} newValue
     * @return {?}
     */
    CodemirrorComponent.prototype.setOptionIfChanged = /**
     * @param {?} optionName
     * @param {?} newValue
     * @return {?}
     */
    function (optionName, newValue) {
        if (!this.codeMirror) {
            return;
        }
        this.codeMirror.setOption(optionName, newValue);
    };
    /**
     * @param {?} focused
     * @return {?}
     */
    CodemirrorComponent.prototype.focusChanged = /**
     * @param {?} focused
     * @return {?}
     */
    function (focused) {
        this.onTouched();
        this.isFocused = focused;
        this.focusChange.emit(focused);
    };
    /**
     * @param {?} cm
     * @return {?}
     */
    CodemirrorComponent.prototype.scrollChanged = /**
     * @param {?} cm
     * @return {?}
     */
    function (cm) {
        this.scroll.emit(cm.getScrollInfo());
    };
    /**
     * @param {?} cm
     * @return {?}
     */
    CodemirrorComponent.prototype.cursorActive = /**
     * @param {?} cm
     * @return {?}
     */
    function (cm) {
        this.cursorActivity.emit(cm);
    };
    /** Implemented as part of ControlValueAccessor. */
    /**
     * Implemented as part of ControlValueAccessor.
     * @param {?} value
     * @return {?}
     */
    CodemirrorComponent.prototype.writeValue = /**
     * Implemented as part of ControlValueAccessor.
     * @param {?} value
     * @return {?}
     */
    function (value) {
        if (value === null || value === undefined) {
            return;
        }
        if (!this.codeMirror) {
            this.value = value;
            return;
        }
        /** @type {?} */
        var cur = this.codeMirror.getValue();
        if (value !== cur &&
            normalizeLineEndings(cur) !== normalizeLineEndings(value)) {
            this.value = value;
            if (this.preserveScrollPosition) {
                /** @type {?} */
                var prevScrollPosition = this.codeMirror.getScrollInfo();
                this.codeMirror.setValue(this.value);
                this.codeMirror.scrollTo(prevScrollPosition.left, prevScrollPosition.top);
            }
            else {
                this.codeMirror.setValue(this.value);
            }
        }
    };
    /** Implemented as part of ControlValueAccessor. */
    /**
     * Implemented as part of ControlValueAccessor.
     * @param {?} fn
     * @return {?}
     */
    CodemirrorComponent.prototype.registerOnChange = /**
     * Implemented as part of ControlValueAccessor.
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onChange = fn;
    };
    /** Implemented as part of ControlValueAccessor. */
    /**
     * Implemented as part of ControlValueAccessor.
     * @param {?} fn
     * @return {?}
     */
    CodemirrorComponent.prototype.registerOnTouched = /**
     * Implemented as part of ControlValueAccessor.
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onTouched = fn;
    };
    /** Implemented as part of ControlValueAccessor. */
    /**
     * Implemented as part of ControlValueAccessor.
     * @param {?} isDisabled
     * @return {?}
     */
    CodemirrorComponent.prototype.setDisabledState = /**
     * Implemented as part of ControlValueAccessor.
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
        this.disabled = isDisabled;
        this.setOptionIfChanged('readOnly', this.disabled);
    };
    CodemirrorComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ngx-codemirror',
                    template: "\n  <textarea\n    [name]=\"name\"\n    class=\"ngx-codemirror {{ className }}\"\n    [class.ngx-codemirror--focused]=\"isFocused\"\n    autocomplete=\"off\"\n    [autofocus]=\"autoFocus\"\n    #ref>\n  </textarea>\n  ",
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef((/**
                             * @return {?}
                             */
                            function () { return CodemirrorComponent; })),
                            multi: true,
                        },
                    ],
                    preserveWhitespaces: false,
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    /** @nocollapse */
    CodemirrorComponent.ctorParameters = function () { return [
        { type: KeyValueDiffers },
        { type: NgZone }
    ]; };
    CodemirrorComponent.propDecorators = {
        className: [{ type: Input }],
        name: [{ type: Input }],
        autoFocus: [{ type: Input }],
        options: [{ type: Input }],
        preserveScrollPosition: [{ type: Input }],
        cursorActivity: [{ type: Output }],
        focusChange: [{ type: Output }],
        scroll: [{ type: Output }],
        ref: [{ type: ViewChild, args: ['ref',] }]
    };
    return CodemirrorComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CodemirrorModule = /** @class */ (function () {
    function CodemirrorModule() {
    }
    CodemirrorModule.decorators = [
        { type: NgModule, args: [{
                    exports: [CodemirrorComponent],
                    declarations: [CodemirrorComponent],
                },] }
    ];
    return CodemirrorModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { CodemirrorComponent, CodemirrorModule };

//# sourceMappingURL=ctrl-ngx-codemirror.js.map